export function usePopUpDialog() {
  function PopUpDialog(pop) {
    if (!(pop instanceof Element)) {
      return;
    }

    const always_show = pop.dataset.alwaysShow === "true";
    const current_id = pop.id;
    const saved_id = localStorage.getItem("cahdco-pop-up");
    const close_button = pop.querySelector(".pop-up__close");

    if (always_show || current_id !== saved_id) {
      pop.showModal();
      localStorage.setItem("cahdco-pop-up", current_id);
    }

    close_button.addEventListener("click", () => {
      pop.close();
    });
  }

  const pop_up = document.querySelector(".pop-up");

  pop_up && PopUpDialog(pop_up);
}
